module.exports = "/static/media/lineto-circular-bold.926416f0.woff";